module.exports = __webpack_public_path__ + "img/image16.c1a4a113.png";